'use client';

import { useState } from 'react';
import { motion } from 'framer-motion';
import Button from '@/components/ui/Button';
import Image from 'next/image';

export default function ShowCase() {
    const wpAsset = process.env.NEXT_PUBLIC_STORAGE_URL
    const [selectedImage, setSelectedImage] = useState(0);
    // Array of image sources
    const images = [
        `${wpAsset}assets/b255c7ab-1565-45aa-b56d-42bfb5264db7.png`,
        `${wpAsset}assets/d480852f-0846-4392-8def-323c78adcbd5.png`,
        `${wpAsset}assets/35d1627e-ad55-4bb3-8c66-cc194e2dabe2.png`,
    ];

    // Click handler to change the image
    const handleButtonClick = (index: number) => {
        setSelectedImage(index);
    };

    return (
        <div className="w-full">
            <div className="flex items-center gap-4 justify-center">
                <Button
                    color="indigo"
                    onClick={() => handleButtonClick(0)}
                    isActive={selectedImage !== 0}
                >
                    Advanced Dashboard
                </Button>
                <Button
                    color="indigo"
                    onClick={() => handleButtonClick(1)}
                    isActive={selectedImage !== 1}
                >
                    Public Profile & Social Media Integration
                </Button>
                <Button
                    color="indigo"
                    onClick={() => handleButtonClick(2)}
                    isActive={selectedImage !== 2}
                >
                    Itinerary Builder
                </Button>
            </div>
            <div className="mt-7">
                <motion.div
                    key={selectedImage} // Unique key for each image to trigger animation
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.9 }}
                    transition={{ duration: 0.5 }}
                >
                    <Image
                        className="w-11/12 mx-auto rounded-lg border"
                        alt="Show Case"
                        src={images[selectedImage]}
                        width={1200}
                        height={800}
                        priority
                    />
                </motion.div>
            </div>
        </div>
    );
}
